import React from "react";
import styles from "../../styles/onlineCounselling.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomImage from "../CustomImage";

interface Props {
  data: any;
}

const OnlineCounFooter: React.FC<Props> = ({ data }) => {
  return (
    <div
      className={styles.footer}
      style={{ backgroundColor: data?.sectionTopBgColor || "#fff" }}
    >
      <Container>
        <Row className="text-center">
          <Col>
            <div className={styles.footerlogo}>
                <CustomImage
                  src="/images/educationfair/kc_logo.svg"
                  width={180}
                  height={45}
                  className={styles.navLogo}
                  alt="kclogo"
                />
            </div>
          </Col>
        </Row>
        {data?.offices?.map((office: any) => (
          <Row>
            <Col>
              <div>
                <p>
                  {office.officeName}: {office.address}
                </p>
                {office.contact && <p>Contact Us: {office.contact}</p>}
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );
};
export default OnlineCounFooter;
